import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Rodape = () => {
  return (
    <Container className="sr-footer">
      <Row>
        <Col className="text-left" xs="6">
            DEPARTAMENTO DE TRÂNSITO DE JOINVILLE/SC (FIXO)
        </Col >
        <Col className="text-right" xs="6">
            Rua XV de Novembro - América, 1383, 89201-602 (FIXO)
            <br/>
            Telefone: 4734311500 | E-mail: detrans@joinville.sc.gov.br(FIXO)
        </Col>       
      </Row>
      <Row className="sr-footer-serpro">
          <Col xs="12">
            <a className="logo-serpro" href="#"></a>
          </Col>
        </Row>
    </Container>
  );
};

export default Rodape;



// WEBPACK FOOTER //
// ./src/componentes/Layout/Rodape.js